import { Directive, HostListener, Input } from "@angular/core";
import { XlsxService } from "./xlsx.service";
import { XlsxExportOptions } from "./interface";

// tslint:disable-next-line:directive-selector
@Directive({ selector: "[xlsx]" })
export class XlsxDirective {
    // tslint:disable-next-line:no-input-rename
    @Input("xlsx")
    data: XlsxExportOptions;

    constructor(private srv: XlsxService) {}

    @HostListener("click")
    _click() {
        this.srv.export(this.data);
    }
}
